import type { Market } from '@backmarket/http-api/src/api-models/Market'
import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { MarketStatus } from '@backmarket/http-api/src/api-models/MarketStatus'
import { MarketplaceCode } from '@backmarket/http-api/src/api-models/MarketplaceCode'
import { Currency } from '@backmarket/http-api/src/standards/Currency'
import { LOCALES } from '@backmarket/http-api/src/standards/Locale'

export const MARKETS: Record<MarketCountryCode, Market> = {
  [MarketCountryCode.AT]: {
    defaultCurrency: Currency.EUR,
    defaultLocale: LOCALES.de_AT,
    domain: '.backmarket.at',
    locales: [LOCALES.de_AT],
    marketplace: MarketplaceCode.EU,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.AT,
  },

  [MarketCountryCode.AU]: {
    defaultCurrency: Currency.AUD,
    defaultLocale: LOCALES.en_AU,
    domain: '.backmarket.com.au',
    locales: [LOCALES.en_AU],
    marketplace: MarketplaceCode.AP,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.AU,
  },

  [MarketCountryCode.BE]: {
    defaultCurrency: Currency.EUR,
    defaultLocale: LOCALES.fr_BE,
    domain: '.backmarket.be',
    locales: [LOCALES.fr_BE],
    marketplace: MarketplaceCode.EU,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.BE,
  },

  [MarketCountryCode.DE]: {
    defaultCurrency: Currency.EUR,
    defaultLocale: LOCALES.de_DE,
    domain: '.backmarket.de',
    locales: [LOCALES.de_DE],
    marketplace: MarketplaceCode.EU,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.DE,
  },

  [MarketCountryCode.ES]: {
    defaultCurrency: Currency.EUR,
    defaultLocale: LOCALES.es_ES,
    domain: '.backmarket.es',
    locales: [LOCALES.es_ES],
    marketplace: MarketplaceCode.EU,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.ES,
  },

  [MarketCountryCode.FI]: {
    defaultCurrency: Currency.EUR,
    defaultLocale: LOCALES.fi_FI,
    domain: '.backmarket.fi',
    locales: [LOCALES.fi_FI],
    marketplace: MarketplaceCode.EU,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.FI,
  },

  [MarketCountryCode.FR]: {
    defaultCurrency: Currency.EUR,
    defaultLocale: LOCALES.fr_FR,
    domain: '.backmarket.fr',
    locales: [LOCALES.fr_FR],
    marketplace: MarketplaceCode.EU,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.FR,
  },

  [MarketCountryCode.GB]: {
    defaultCurrency: Currency.GBP,
    defaultLocale: LOCALES.en_GB,
    domain: '.backmarket.co.uk',
    locales: [LOCALES.en_GB],
    marketplace: MarketplaceCode.EU,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.GB,
  },

  [MarketCountryCode.GR]: {
    defaultCurrency: Currency.EUR,
    defaultLocale: LOCALES.el_GR,
    domain: '.backmarket.gr',
    locales: [LOCALES.el_GR],
    marketplace: MarketplaceCode.EU,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.GR,
  },

  [MarketCountryCode.IE]: {
    defaultCurrency: Currency.EUR,
    defaultLocale: LOCALES.en_IE,
    domain: '.backmarket.ie',
    locales: [LOCALES.en_IE],
    marketplace: MarketplaceCode.EU,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.IE,
  },

  [MarketCountryCode.IT]: {
    defaultCurrency: Currency.EUR,
    defaultLocale: LOCALES.it_IT,
    domain: '.backmarket.it',
    locales: [LOCALES.it_IT],
    marketplace: MarketplaceCode.EU,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.IT,
  },

  [MarketCountryCode.JP]: {
    defaultCurrency: Currency.JPY,
    defaultLocale: LOCALES.ja_JP,
    domain: '.backmarket.co.jp',
    locales: [LOCALES.ja_JP],
    marketplace: MarketplaceCode.AP,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.JP,
  },

  [MarketCountryCode.NL]: {
    defaultCurrency: Currency.EUR,
    defaultLocale: LOCALES.nl_NL,
    domain: '.backmarket.nl',
    locales: [LOCALES.nl_NL],
    marketplace: MarketplaceCode.EU,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.NL,
  },

  [MarketCountryCode.PT]: {
    defaultCurrency: Currency.EUR,
    defaultLocale: LOCALES.pt_PT,
    domain: '.backmarket.pt',
    locales: [LOCALES.pt_PT],
    marketplace: MarketplaceCode.EU,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.PT,
  },

  [MarketCountryCode.SE]: {
    defaultCurrency: Currency.SEK,
    defaultLocale: LOCALES.sv_SE,
    domain: '.backmarket.se',
    locales: [LOCALES.sv_SE],
    marketplace: MarketplaceCode.EU,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.SE,
  },

  [MarketCountryCode.SK]: {
    defaultCurrency: Currency.EUR,
    defaultLocale: LOCALES.sk_SK,
    domain: '.backmarket.sk',
    locales: [LOCALES.sk_SK],
    marketplace: MarketplaceCode.EU,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.SK,
  },

  [MarketCountryCode.US]: {
    defaultCurrency: Currency.USD,
    defaultLocale: LOCALES.en_US,
    domain: '.backmarket.com',
    locales: [LOCALES.en_US],
    marketplace: MarketplaceCode.NA,
    status: MarketStatus.OPEN,
    countryCode: MarketCountryCode.US,
  },
}

export const DEFAULT_MARKET = MARKETS[MarketCountryCode.US]
